
export const BooleanTable = ({ title, data, statusInfo }) => {
    if (!statusInfo) return null;

    const renderBooleanValue = (value, colored = false, reverseColors = false) => {
      if (value === undefined || value === null) return "-";

      const text = value ? "True" : "False";

      if (!colored) return text;

      // Default: true = red, false = green
      // Reversed: true = green, false = red
      const color = reverseColors
        ? (value ? '#28a745' : '#dc3545')
        : (value ? '#dc3545' : '#28a745');

      return (
        <span style={{
          color: color,
          fontWeight: '500'
        }}>
          {text}
        </span>
      );
    };

    return (
      <>
        <h6 className="fw-bold text-muted">{title}</h6>
        <table className="table main-background">
          <tbody>
            {data.map(({ label, key, colored = false, reverseColors = false, type = 'boolean' }) => (
              <tr key={key} className="text-start">
                <td><strong className="text-muted">{label}</strong></td>
                <td className="text-end text-muted">
                  {type === 'text'
                    ? (statusInfo[key] || "-")
                    : renderBooleanValue(statusInfo[key], colored, reverseColors)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </>
    );
  };